var klaviyo = klaviyo || [];
    klaviyo.init({
      account: "QBj245",
      platform: "shopify"
    });
    klaviyo.enable("backinstock",{ 
    trigger: {
      product_page_text: "Obavijesti me kad proizvod bude dostupan",
      product_page_class: "button",
      product_page_text_align: "center",
      product_page_margin: "0px",
      replace_anchor: false
    },
    modal: {
     headline: "{product_name}",
     body_content: "Registriraj se kako bi primio obavijest kada ovaj proizvod ponovno bude dostupan na zalihama.",
     email_field_label: "Email",
     button_label: "Obavijesti me kad bude dostupno",
     subscription_success_label: "Uspješna prijava! Obavijestit ćemo te kada ponovno bude dostupan.",
     footer_content: '',
     additional_styles: "border-radius: 10px;",
     drop_background_color: "#000",
     background_color: "#fff",
     text_color: "#222",
     button_text_color: "#fff",
     button_background_color: "#3aaa35",
     close_button_color: "#ccc",
     error_background_color: "#fcd6d7",
     error_text_color: "#C72E2F",
     success_background_color: "#3aaa35",
     success_text_color: "#1B9500"
    }
  });